import DocumentDetailsResponse from "../account/documentDetailsResponse";
import BaseClient from "../baseClient";
import SamplesLoadResponse from "./samplesLoadResponse";

const samples = {
    usrSample: require("../../../samples/UtilitySearchReportSample.pdf"),
    usmEssentialSample: require("../../../samples/US_Sample_UtilitySearchMap_Essential.pdf"),
    usmStandardSample: require("../../../samples/US_Sample_UtilitySearchMap_Standard.pdf"),
    usmAdvancedSample: require("../../../samples/US_Sample_UtilitySearchMap_Advanced.pdf"),
    ussSample: require("../../../samples/UtilitySearchSummary_Sample.pdf"),
    ulvSample: require("../../../samples/US_Utility Legal View_Sample_April 2025.pdf"),
}

/**
 * Client for calling actions on the Samples controller.
 */
export default class SamplesClient extends BaseClient {

    public LoadSamples() : SamplesLoadResponse
    {
        console.log(samples);

        return {
                usrSample: this.CreateStaticDocumentResponse(samples.usrSample),
                usmEssentialSample: this.CreateStaticDocumentResponse(samples.usmEssentialSample),
                usmStandardSample: this.CreateStaticDocumentResponse(samples.usmStandardSample),
                usmAdvancedSample: this.CreateStaticDocumentResponse(samples.usmAdvancedSample),
                ussSample: this.CreateStaticDocumentResponse(samples.ussSample),
                ulvSample: this.CreateStaticDocumentResponse(samples.ulvSample),
            } as SamplesLoadResponse;
    }

    private CreateStaticDocumentResponse(filePath: string): DocumentDetailsResponse
    {
        const fileName = filePath.split('/').pop();
        const path = new URL(filePath).pathname;

        return {
            fileName: fileName,
            uploadedDate: new Date("05/02/2026").toISOString(),
            blobUrl: path,
            description: "",
            fileTypeOptions: [],
            fileTypeSelected: 0,
        }
    }

}